import { VideoControlButtons } from './VideoControlButtons';
import { VideoTrimFrame } from './VideoTrimFrame';
import { VideoVirtualProgress } from './VideoVirtualProgress';
import { VideoTimeLine } from './VideoTimeLine';
import { RefObject, useRef } from 'react';

type VideoPanelProps = {
  timeRange: [number, number];
  onChange: (value: [number, number]) => void;
  height: number;
  width: number;
  videoRef: RefObject<HTMLVideoElement>;
  progressRef: RefObject<HTMLDivElement>;
  duration: number;
  src: string;
  ratio: number;
  isPlaying: boolean;
  setIsPlaying: React.Dispatch<React.SetStateAction<boolean>>;
  limitTimeRangeDistance: number;
  isMaxRangeLimit: boolean;
  hideTrimFrame: boolean;
};

export const VideoPanel = (p: VideoPanelProps) => {
  const parentRef = useRef<HTMLDivElement | null>(null);

  const updateVirtualProgress = (e: React.MouseEvent<HTMLDivElement>) => {
    const { left, width } = (
      parentRef.current as HTMLDivElement
    ).getBoundingClientRect();
    const x = e.clientX - left;
    const percentage = (x / width) * 100;
    const percentageBounded = Math.max(
      p.timeRange[0],
      Math.min(percentage, p.timeRange[1]),
    );

    if (p.progressRef.current) {
      p.progressRef.current.style.left = `${percentageBounded}%`;
      p.progressRef.current.style.transform = `initial`;
    }

    const time = (percentageBounded / 100) * p.duration;
    if (p.videoRef?.current) p.videoRef.current.currentTime = time;
  };
  return (
    <div className="flex gap-2 items-center">
      <VideoControlButtons {...p} />

      <div
        style={{
          padding: `5px ${15}px`,
          width: p.width + 15 * 2,
        }}
      >
        <div style={{ width: p.width }}>
          <div
            ref={parentRef}
            className="w-full relative"
            style={{ height: p.height }}
            onClick={updateVirtualProgress}
          >
            <VideoTimeLine
              duration={p.duration}
              height={p.height}
              width={p.width}
              src={p.src}
              ratio={p.ratio}
            />
            {!p.hideTrimFrame && (
              <VideoTrimFrame
                value={p.timeRange}
                onChange={p.onChange}
                duration={p.duration}
                limitTimeRangeDistance={p.limitTimeRangeDistance}
                isMaxRangeLimit={p.isMaxRangeLimit}
              />
            )}
            <VideoVirtualProgress
              width={4}
              parentWidth={p.width}
              progressRef={p.progressRef}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
